module.exports = __webpack_public_path__ + "img/2018-12-16-4.07c52281.jpeg";